
import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useCurrentUserFamily } from '@/hooks/useCurrentUserFamily';
import { activityFeedService } from '@/services/activity';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import ActivityItem from '@/components/activity/ActivityItem';

const RecentActivity: React.FC = () => {
  const { familyId, hasFamily } = useCurrentUserFamily();

  const { data: response, isLoading } = useQuery({
    queryKey: ['recent-family-activities', familyId],
    queryFn: () => activityFeedService.getFamilyActivities(familyId!, 3, 0),
    enabled: !!familyId && hasFamily,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });

  const activities = response?.data || [];

  if (isLoading) {
    return (
      <div>
        <div className="space-y-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex items-start gap-3 p-4 bg-card rounded-lg border border-golden-light shadow-sm">
              <Skeleton className="h-8 w-8 rounded-full" />
              <div className="flex-1 space-y-2">
                <Skeleton className="h-4 w-3/4" />
                <Skeleton className="h-3 w-1/4" />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!hasFamily || !familyId) {
    return (
      <div>
        <div className="text-center py-8 px-4 bg-muted/30 rounded-lg">
          <p className="text-sm text-muted-foreground mb-4">
            Join a family circle to see recent activities.
          </p>
          <Link to="/family-circle">
            <Button size="sm">View Family Circle</Button>
          </Link>
        </div>
      </div>
    );
  }

  if (activities.length === 0) {
    return (
      <div>
        <div className="text-center py-8 px-4 bg-muted/30 rounded-lg">
          <p className="text-sm text-muted-foreground">
            No recent family activities yet.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="space-y-4">
        {activities.map((activity) => (
          <ActivityItem key={activity.id} activity={activity} />
        ))}
      </div>
    </div>
  );
};

export default RecentActivity;
